import { gql } from "@apollo/client";

export const GET_LATEST_HEALTH_STATUS = gql`
  query LatestHealthStatus($animalId: String!) {
    latestHealthStatus(animalId: $animalId) {
      time
      weight
      weightUnits
      temperature
      temperatureUnit
      heartRate
      respiratoryRate
      bcs
      maxBcs
      painScore
      maxPainScore
      dentalScore
      maxDentalScore
      crt
      mm
      attitude
      notes
    }
  }
`;

export const GET_MEDICAL_RECORD_PDF = gql`
  query MedicalRecordDetailPdf($animalId: String!) {
    medicalRecordDetailPdf(animalId: $animalId) {
      url
      filename
    }
  }
`;

export const GET_RABIES_VACCINATION_LIST = gql`
  query RabiesVaccinationList($animalId: String!) {
    rabiesVaccinationList(animalId: $animalId) {
      vaccinationName
      administeredAt
      dueAt
      administeredBy
    }
  }
`;

export const GET_RABIES_CERTIFICATE_PDF = gql`
  query RabiesVaccinationCertificatePdf($animalId: String!) {
    rabiesVaccinationCertificatePdf(animalId: $animalId) {
      url
      filename
    }
  }
`;
